import { authUtils } from '../utils/auth';

export interface UserProfile {
  email: string;
  iasc: number;
  ics: number;
  idg: number;
  idp: number;
  ijde: number;
  ichat: number;
  ipm: number;   // Profile Match - Input tokens
  oasc: number;
  ocs: number;
  odg: number;
  odp: number;
  ojde: number;
  ochat: number;
  opm: number;   // Profile Match - Output tokens
  expiry: number;
  type: number;
  rt?: string;
  ct?: string;
  jms?: number;  // Job Minimum Score (0-100, 0 = disabled)
  baa?: boolean; // Bot Auto Apply opt-in flag
}

export interface TemplatesResponse {
  success: boolean;
  results: {
    rt: string[];
    ct: string[];
  };
}

const SETTINGS_SERVICE_URL = 'https://settings-545273374205.europe-north2.run.app';
const PDF_GENERATOR_URL = 'https://pdf-generator-545273374205.europe-north2.run.app';

export const settingsService = {
  async getProfile(): Promise<UserProfile | null> {
    const token = authUtils.getToken();
    const response = await fetch(`${SETTINGS_SERVICE_URL}/api/profile`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) throw new Error('Failed to load profile');
    const data = await response.json();
    return data.success ? data.profile : null;
  },

  async getTemplates(): Promise<TemplatesResponse> {
    const token = authUtils.getToken();
    const response = await fetch(`${PDF_GENERATOR_URL}/templates`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) throw new Error('Failed to load templates');
    return await response.json();
  },

  async setResumeTemplate(template: string): Promise<boolean> {
    const token = authUtils.getToken();
    const response = await fetch(`${SETTINGS_SERVICE_URL}/api/set-resume-template`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ template }),
    });

    if (!response.ok) throw new Error('Failed to update resume template');
    const data = await response.json();
    return data.success;
  },

  async setCoverLetterTemplate(template: string): Promise<boolean> {
    const token = authUtils.getToken();
    const response = await fetch(`${SETTINGS_SERVICE_URL}/api/set-cover-letter-template`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ template }),
    });

    if (!response.ok) throw new Error('Failed to update cover letter template');
    const data = await response.json();
    return data.success;
  },

  async setJMS(jms: number): Promise<boolean> {
    const token = authUtils.getToken();
    const response = await fetch(`${SETTINGS_SERVICE_URL}/api/set-jms`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ jms }),
    });

    if (!response.ok) throw new Error('Failed to update JMS');
    const data = await response.json();
    return data.success;
  },

  async setBAA(baa: boolean): Promise<boolean> {
    const token = authUtils.getToken();
    const response = await fetch(`${SETTINGS_SERVICE_URL}/api/set-baa`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ baa }),
    });

    if (!response.ok) throw new Error('Failed to update auto-apply preference');
    const data = await response.json();
    return data.success;
  },
};
